import React from 'react';

function PopupOrderSuccess({ onClose, onOpenFeedback }) {
  return (
    <div className="popup__overlay" onClick={onClose}>
      <div className="popup-order-success" onClick={(event) => event.stopPropagation()}>
        <h2 className="popup-order-success__heading">Заявка принята!</h2>
        <p className="popup-order-success__text">
          Статус заказа придет на вашу почту. Оператор свяжется с вами для подтверждения заказа,
          а если звонок не поступит в течении 15 минут, пожалуйста, позвоните нам самостоятельно.
        </p>
        <button
          className="popup-order-success__feedback-button"
          type="button"
          onClick={() => {
            onClose();
            onOpenFeedback();
          }}
        >
          Оставить отзыв
        </button>
        <button className="popup-order-success__close-button" onClick={onClose}>✖</button>
      </div>
    </div>
  );
}

export default PopupOrderSuccess;
